import { useLayoutEffect, useRef, type RefObject } from 'react';
import { installMobileDrawer, type DrawerController } from './drawer';

export function useMobileDrawer(
  shell: RefObject<HTMLDivElement | null>,
  state: {
    open: boolean;
    blocked: boolean;
    chat: boolean;
    onChange: (open: boolean) => void;
  },
) {
  const current = useRef(state);
  current.current = state;
  const controller = useRef<DrawerController | null>(null);
  useLayoutEffect(() => {
    const drawer = shell.current?.querySelector<HTMLElement>('.mobile-drawer');
    const surface = shell.current?.querySelector<HTMLElement>('.ws-main-column');
    const overlay = shell.current?.querySelector<HTMLElement>('.mobile-drawer-overlay');
    if (!drawer || !surface || !overlay || typeof window.matchMedia !== 'function') return;
    const installed = installMobileDrawer({
      drawer,
      surface,
      overlay,
      initialOpen: current.current.open,
      canStart: () => !current.current.blocked,
      canSwipeAnywhere: () => current.current.chat,
      onStateChange: (next) => current.current.onChange(next),
    });
    controller.current = installed;
    return () => {
      installed.destroy();
      controller.current = null;
    };
  }, [shell]);
  useLayoutEffect(() => {
    controller.current?.sync(state.open && !state.blocked);
  }, [state.open, state.blocked]);
}
